module.exports = __webpack_public_path__ + "static/media/ecommerce.d162a975.jpg";